<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>

  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {COMPLETED_SCREENING} from '../../../../Config/ScreeningAppUrl'
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {Candidate} from "@Views/Screening/utility/apiAgent";
import {mergeDateTime} from "@Views/Screening/utility/common/candidate";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import {GET_COMPANY_USERS} from "@/app/Config/ApiUrl";
import {APPLICANT_FILES} from "@/app/Config/ScreeningAppUrl";
import * as actions from "@/app/Config/ApiUrl";


export default {
  extends: CoreLibrary,
  name: "ScreeningCompleted",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      tableId: "advance-table",
      rowData: {},
      screeningChecklists: [],
      localChecklists: [],

      options: {
        name: "AdvanceTable",
        url: COMPLETED_SCREENING,
        showHeader: true,
        columns: [
          {
            title: this.$t("Id"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${value.id}</span>`;
            },
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${this.$t(value.full_name)}</span>`;
            },
          },

          {
            title: this.$t("Application Received"),
            type: "custom-html",
            key: "created_at",
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("progress"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${value.completion_percentage}</span>`;
            },
          },
          {
            title: this.$t("Screening Start Date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Screening Completion Date"),
            type: "custom-html",
            key: "completed_at",
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },

          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Screening Type"),
            type: "custom-html",
            key: "screening_type",
            modifier: (value) => {
              return `<span>${this.$t(value??'Internal')}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "file-plus",
            type: "none",
          },

          {
            title: this.$t("download_full_screening_report"),
            icon: "file-plus",
            type: "none",
          },
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      vetting: {},
      users: [],
      select_user: '',
      applicantFiles: [],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    openCandidateDetail(rowData) {
      if (!rowData || !rowData.company_id || !rowData.applicant_id) {
        console.error("Invalid rowData:", rowData);
        return;
      }

      const url = `/candidate-detail/${rowData.company_id}/${rowData.applicant_id}?tab=Upload%20Documents`;
      window.open(url, "_blank");
    },
    mergeDateTime,
    getPageTitle() {
      let pageTitle = 'Completed Screening';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("view")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.applicant_id}`, '_blank' );
      } else if (actionObj.title == this.$t("download_full_screening_report")) {
        window.open('/generate-candidate-screening-report/full_screening?applicant_id='+rowData.applicant_id, '_blank');
      }
      }
    },

  computed:{
    today(){
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = today.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }
  },

};
</script>